<template>
  <div>
    <!-- Add submenu -->
    <div class="submenu mb-4">
      <button
        v-for="(item, index) in menuItems"
        :key="index"
        @click="activeView = item.value"
        :class="['menu-button', { active: activeView === item.value }]"
      >
        {{ item.label }}
      </button>
    </div>

    <!-- Conditional rendering of components -->
    <company-tree-planting-chart
      v-if="activeView === 'charts'"
      class="mb-10"
      :id="id"
    />
    <company-tree-planting-table
      v-if="activeView === 'table'"
      class="mb-10"
      :id="id"
    />
    <company-tree-planting-review-direct
      v-if="activeView === 'rf-direct'"
      class="mb-10"
      :id="id"
    />
  </div>
</template>

<script>
import CompanyTreePlantingChart from "./CompanyTreePlantingChart.vue";
import CompanyTreePlantingTable from "./CompanyTreePlantingTable.vue";
import CompanyTreePlantingReviewDirect from "./CompanyTreePlantingReviewDirect.vue";

export default {
  name: "CompanyTreePlanting",
  components: {
    CompanyTreePlantingChart,
    CompanyTreePlantingTable,
    CompanyTreePlantingReviewDirect,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeView: "charts",
      menuItems: [
        { label: "Charts", value: "charts" },
        { label: "Table", value: "table" },
        { label: "RF Direct", value: "rf-direct" },
      ],
    };
  },
};
</script>

<style scoped>
.submenu {
  display: flex;
  gap: 1rem;
}

.menu-button {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  width: 150px;
}

.menu-button.active {
  background: rgb(226, 225, 225);
  color: black;
  border-color: rgb(226, 225, 225);
}
</style>
